import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { once, get } from 'lodash-es';
import { withRouter } from 'react-router-dom';

import { loadMicrosoftTeamsSDK } from 'utils/microstoft-teams';
import { setMicrosoftTeamsLoadedAction } from 'common/actions/settings';
import { getShareViaMicrosoftTeamsSelector } from 'common/selectors/settings';
import { SimpleDropDownElement } from 'components/simple-dropdown/index';
import { getBase64SharePathSelector } from '../selectors';
import { ReactComponent as MsTeamsLogo } from './ms-teams-logo.svg';

const loadMicrosoftTeamsSDKOnce = once(async (setMicrosoftTeamsLoaded) => {
  try {
    await loadMicrosoftTeamsSDK();
    setMicrosoftTeamsLoaded();
  } catch (error) {
    // we handle the errors in the loader
  }
});

const shareViaMicrosoftTeams = () => {
  const shareButton = window.document.getElementById('ms-teams-share-button').getElementsByTagName('a')[0];
  shareButton.click();
};

const MsTeamsButton = ({
  videoShareUrl,
  setMicrosoftTeamsLoaded,
  isShareViaMicrosoftTeamsEnabled,
  isMSTeamsLoaded,
}) => {
  useEffect(() => {
    if (isShareViaMicrosoftTeamsEnabled) {
      loadMicrosoftTeamsSDKOnce(setMicrosoftTeamsLoaded);
    }
  }, [setMicrosoftTeamsLoaded, isShareViaMicrosoftTeamsEnabled]);

  useEffect(() => {
    if (isMSTeamsLoaded) {
      window.shareToMicrosoftTeams?.renderButtons();
    }
  }, [isMSTeamsLoaded]);

  return isMSTeamsLoaded ? (
    <div data-e2e="ms-teams">
      <SimpleDropDownElement onClick={shareViaMicrosoftTeams}>
        <MsTeamsLogo /> Microsoft Teams
        <div id="ms-teams-share-button" className="teams-share-button" data-href={videoShareUrl} />
      </SimpleDropDownElement>
    </div>
  ) : null;
};

const mapStateToProps = (state, props) => {
  const params = props.match && props.match.params;
  const sharePath = getBase64SharePathSelector(params)(state);

  return {
    videoShareUrl: `${window.location.origin}/api/share?p=${sharePath}`,
    isMSTeamsLoaded: get(getShareViaMicrosoftTeamsSelector(state), 'loaded'),
    isShareViaMicrosoftTeamsEnabled: get(getShareViaMicrosoftTeamsSelector(state), 'enabled'),
  };
};

export const MsTeamsButtonDecorated = compose(
  withRouter,
  connect(mapStateToProps, {
    setMicrosoftTeamsLoaded: setMicrosoftTeamsLoadedAction,
  })
)(MsTeamsButton);
